import Menu from "./menu";
import Background from "./pages/background";
import Projects from "./pages/projects";
import Contact from "./pages/contact";
import Description from "./description";
import Splash from "./splashPage";
import Header from "./header";
import Footer from "./footer";
const pages = {
  Background,
  Projects,
  Contact,
};
export { Menu, pages, Description, Splash, Header, Footer };
